import { ErrorBoundary } from "@sentry/nextjs";
import { GetStaticProps } from "next";

import { NEXT_PAGE_REVALIDATE } from "@/shared/constants";

import serverSideTranslations from "@/utils/serverSideTranslations";

import SimpleLayout from "@/layouts/simple";

import { LocaleProvider, useCurrentLocale } from "@/context/LanguageContext";

import ErrorMessage from "@/components/error/error";

import { Locale } from "@/types/locale";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        revalidate: NEXT_PAGE_REVALIDATE,
        props: {
            locale,
            _nextI18Next: await serverSideTranslations(locale as Locale),
        },
    };
};

const FiveHundred: React.FC<{ locale: Locale }> = () => {
    const locale = useCurrentLocale();

    const errorTitle = "An error occurred",
        errorHeading = "An error occurred.",
        errorSubHeading = "Let's get you back on the right path.",
        errorCTALabel = "Shop now";

    const errorMessageComponent = (
        <ErrorMessage
            heading={errorHeading}
            subHeading={errorSubHeading}
            ctaLabel={errorCTALabel}
            ctaUrl={"/"}
        />
    );

    return (
        <ErrorBoundary fallback={errorMessageComponent}>
            <LocaleProvider locale={locale}>
                <SimpleLayout title={errorTitle} preventIndexing={true}>
                    {errorMessageComponent}
                </SimpleLayout>
            </LocaleProvider>
        </ErrorBoundary>
    );
};

export default FiveHundred;
